import { TranslateService } from '@ngx-translate/core';
import { HighChartDataBase } from './high-chart-data-base';
import moment from 'moment';
import { ClickDataPoint, ClickNotifier } from './click-notifier';

export class ColumnRangeHighChartData extends HighChartDataBase {

    constructor(
        protected override translate: TranslateService,
        protected override jsonData?: any,
        protected override width?: any,
        protected override height?: any,
        protected override clickNotifier?: ClickNotifier) {
        super(translate, jsonData, width, height, clickNotifier);
    }

    public getHighChartOptions(): Object {
        let that = this;
        let options = {
            accessability: { enabled: false },
            chart: {
                type: 'columnrange',
                height: this.chartHeight,
                zoomType: 'x',
                resetZoomButton: {
                    position: { x: 0, y: -45 }
                },
                panning: true,
                panKey: 'shift'
            },
            title: {
                text: this.chartTitle,
                widthAdjust: -150,
                margin: 30
            },
            subtitle: {
                text: this.chartSubTitle ,
                widthAdjust: -150
            },
            yAxis: {
                title: {
                    text: this.yAxisTitle
                },
                plotLines: [{
                    value: this.targetLine,
                    color: '#4f678f',
                    dashStyle: 'LongDash',
                    width: this.targetLineWidth,
                    zIndex: 5 // framför staplar Och ticks-linjer
                }],
                labels: {
                    formatter: function() {
                        if (that.isDateTime(moment(this.value)))
                            return moment(this.value).locale("sv").format("YYYY-MM");
                        else
                            return this.value;
                    }
                },
                min: Number.isNaN(this.yMinValue) ? null : this.yMinValue,
                max: Number.isNaN(this.yMaxValue) ? null : this.yMaxValue,
                allowDecimals: this.seriesContainsDecimals
            },
            series: this.chartSeries,
            xAxis: {
                type: "category",
                categories: this.categories,
                title: {
                    text: this.xAxisTitle
                },
                labels: {
                    step: (document.getElementById("chart-wrapper") ? (document.getElementById("chart-wrapper").clientWidth > 750 ? (this.categories.length < 100 ? 1 : null) : null) : null),
                    rotation: this.xAxisLabelRotation,
                    style: {
                        fontSize: this.categories.length > 50 && this.categories.length < 100 ? '10px' : '11px'
                    },
                    formatter: function () {
                        for (var i = 0; i < that.categories.length; i++) {
                            if (that.categories[i] === this.value) {
                                if (that.xAxisColors && that.xAxisColors[i] != '')
                                    return '<span style="fill: ' + that.xAxisColors[i] + ';">' + this.value + '</span>';
                                else
                                    return this.value;
                            }
                        }
                    }
                },
                min: Number.isNaN(this.xMinValue) ? null : this.xMinValue,
                max: Number.isNaN(this.xMaxValue) ? null : this.xMaxValue
            },
            tooltip: {
                formatter: function() {
                    let text = '<u style="font-size:11px">' + this.x + '</u><table>';
                    if (this.points) {
                        this.points.forEach((points) => {
                            let lowerValue = (that.isDateTime(moment(points.point.high))) ? moment(points.point.high).locale("sv").format("YYYY-MM-DD HH:mm") : points.point.high;
                            let upperValue = (that.isDateTime(moment(points.point.low))) ? moment(points.point.low).locale("sv").format("YYYY-MM-DD HH:mm") : points.point.low;

                            text += that.chartSeries.length > 1 ? '<tr><td style="padding:0 5px 0 0; font-weight:500"><i>' + points.series.name + '</i></td></tr><tr>' : "<tr>";
                            text += "<td>"+ that.translate.instant('xml-report.table.rangecolumn.upper') +":&ensp;</td><td><b>" + upperValue + " " + that.displayUnit + "</b></td></tr>";
                            text += "<td>"+ that.translate.instant('xml-report.table.rangecolumn.lower') +":&ensp;</td><td><b>" + lowerValue + " " + that.displayUnit + "</b></td></tr>";
                        });
                    } else if (this.point) {
                        if (this.point.y == 0) return false;
                        return that.getDefaultTooltipText(this, true);
                    }
                    text += "</table>";
                    return text;
                },
                shared: true,
                useHTML: true
            },
            plotOptions: {
                columnrange: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    point: {
                        events: {
                            click: function () {
                                if (that.clickNotifier) {
                                    that.clickNotifier.handleClick(new ClickDataPoint(this.category, this.series.name, this.y));
                                }
                            }
                        }
                    }
                }
            },
            colors: this.defaultColors,
            legend: {
                enabled: this.chartSeries.length > 1
            },
            credits: {
                text: this.credits,
                href: this.creditsLink
            },

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: this.chartWidth
                    }
                }]
            },

            exporting: {
                filename: "diagram_" + this.chartTitle
            }
        };

        return options;
    }
}
